import styled from 'styled-components';
import { TextLinkBack } from '@nebula/text-link';

export const DeactivateWrapper = styled.div<{ $isWebview?: boolean }>`
  background: #fff;
  min-height: 60vh;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    display: flex;
    justify-content: center;
    background: ${({ theme }) => theme.color.ui.grey[10]};
  }
`;

export const DeactivateContainer = styled.div<{ $isWebview?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: 100%;
    padding: ${({ $isWebview }) => ($isWebview ? '0 16px' : '0 24px')};
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    padding: ${({ $isWebview }) => ($isWebview ? '0 16px' : '0')};
    max-width: ${({ $isWebview }) => ($isWebview ? '100%' : '802px')};
  }
`;

export const DeactivateContentContainer = styled.div``;

export const ContentCard = styled.div<{ $isWebview?: boolean; $tabletMarginTop?: string; $noPaddingBottom?: boolean }>`
  background: #fff;
  padding: ${({ $isWebview, $noPaddingBottom }) => ($isWebview ? `16px 0 ${$noPaddingBottom ? '0' : '16px'}` : '')};
  margin-top: ${({ $isWebview }) => ($isWebview ? '0' : '16px')};
  margin-bottom: ${({ $isWebview }) => ($isWebview ? '0' : '24px')};

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    border-radius: ${({ $isWebview }) => ($isWebview ? '0' : '12px')};
    padding: ${({ $isWebview }) => ($isWebview ? '24px 0' : '24px')};
    margin-top: ${({ $isWebview, $tabletMarginTop }) => ($isWebview ? '0' : ($tabletMarginTop ?? '16px'))};
    margin-bottom: ${({ $isWebview }) => ($isWebview ? '16px' : '32px')};
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    padding: ${({ $isWebview }) => ($isWebview ? '24px 0' : '32px')};
  }
`;

export const BackLinkWrapper = styled(TextLinkBack)<{ $isWebview?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: ${({ $isWebview }) => ($isWebview ? '16px 0 0' : '16px 8px 0 8px')};

  @media (min-width: 375px) {
    padding: 16px 0 0;
  }

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding-top: 24px;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    padding-top: 32px;
    margin-bottom: 8px;
  }
`;
